// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__XOWMF","ssr-layout":"styles_ssr-layout__bDdEA","layoutContainer":"styles_layoutContainer__jxqX8"};